import { render, staticRenderFns } from "./WorkAddressReadonlyLayout.vue?vue&type=template&id=320c0ec5&scoped=true"
import script from "./WorkAddressReadonlyLayout.vue?vue&type=script&lang=js"
export * from "./WorkAddressReadonlyLayout.vue?vue&type=script&lang=js"
import style0 from "./WorkAddressReadonlyLayout.vue?vue&type=style&index=0&id=320c0ec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c0ec5",
  null
  
)

export default component.exports